import React, { useEffect, useRef, useState } from "react";
import Editor from "@monaco-editor/react";
import CodeViewBlocksComponent from "./CodeViewBlocksComponent";
import { Block } from "baseui/block";

const CodeViewEditor = ({ fileName, viewMode, content, onContentChange, parameterGroups }) => {
  const editorRef = useRef(null);
  const [editorKey] = useState(Date.now());

  // Determine if we should use block view based on dictionary name
  const shouldUseBlockView = (dictName) => {
    // List of dictionaries that support block view - all uppercase
    // const validDictionaries = ['CONTROLDICT', 'FVSCHEMES', 'FVSOLUTION', 'DECOMPOSEPARDICT', 'TRANSPORTPROPERTIES'];
    const validDictionaries = []
    // Extract just the filename without path or extension and convert to uppercase
    const cleanDictName = dictName?.split('/').pop()?.split('.')[0]?.toUpperCase();
    
    console.log('Checking block view support:', {
      originalDictName: dictName,
      cleanDictName,
      isValid: validDictionaries.includes(cleanDictName)
    });
    
    return validDictionaries.includes(cleanDictName);
  };

  const handleEditorDidMount = (editor, monaco) => {
    editorRef.current = editor;
    editor.setValue(content || "");
    
    // Configure editor options
    editor.updateOptions({
      minimap: { enabled: false },
      scrollBeyondLastLine: false,
      language: 'cpp',
      fontSize: 16,
      lineNumbers: 'on',
      wordWrap: 'on',
      automaticLayout: true,
      readOnly: viewMode === 0 // Set readOnly based on viewMode
    });
  };

  const handleEditorChange = (newValue, event) => {
    if (onContentChange) {
      onContentChange(newValue);
    }
  };

  // Determine which view to show based on viewMode and dictionary type
  const renderView = () => {
    const isBlockViewSupported = shouldUseBlockView(fileName);
    
    console.log('Rendering view:', {
      fileName,
      viewMode,
      isBlockViewSupported
    });
    
    // In view mode (viewMode === 0)
    if (viewMode === 0) {
      if (isBlockViewSupported) {
        // Show block view for supported dictionaries
        return (
          <Block $style={{ height: '800px', width: '100%' }}>
            <CodeViewBlocksComponent 
              dictName={fileName} 
              fileContent={content} 
              parameterGroups={parameterGroups}
            />
          </Block>
        );
      } else {
        // Show pre element for unsupported dictionaries
        return (
          <Block $style={{ height: '800px', width: '100%', margin: '20px 0' }}>
            <pre
              style={{
                whiteSpace: "pre-wrap",
                wordWrap: "break-word",
                fontSize: "14px",
                height: "800px",
                resize: "none",
                margin: "20px",
                backgroundColor: "#f5f5f5",
                padding: "20px",
                borderRadius: "4px",
                overflow: "auto"
              }}
              className="language-cpp"
            >
              <code>{content}</code>
            </pre>
          </Block>
        );
      }
    }
    
    // In edit mode (viewMode === 1)
    // Always show editor in edit mode, regardless of dictionary type
    return (
      <Block $style={{ height: '800px', width: '100%', margin: '20px 0' }}>
        <Editor
          key={editorKey}
          height="100%"
          width="100%"
          language="cpp"
          theme="vs-light"
          value={content}
          options={{
            minimap: { enabled: false },
            scrollBeyondLastLine: false,
            fontSize: 16,
            lineNumbers: 'on',
            wordWrap: 'on',
            automaticLayout: true,
            readOnly: false // Allow editing in edit mode
          }}
          onMount={handleEditorDidMount}
          onChange={handleEditorChange}
        />
      </Block>
    );
  };

  return renderView();
};

export default CodeViewEditor;
